module.exports = __webpack_public_path__ + "static/media/16UNODC38.52a48923.jpg";